<mat-sidenav-container>
    <mat-sidenav #sidenav mode="side" position="end">
        <app-document-viewer #documentViewer (close)="toggleSlide(); documentLoadUnsubscriber$.next()"
            [documentDetails]="selectedDocumentDetails"></app-document-viewer>
    </mat-sidenav>

    <mat-sidenav-content [class.opened]="isOpened">
        <div class="main-container lg-view">
            <p class="proposal-status {{ ProposalStatus[approvalRequest.proposalStatusId]?.toLowerCase() }}">
                {{ ProposalStatus[approvalRequest.proposalStatusId]?.toUpperCase() }}
            </p>
            <h3>Approval Request</h3>

            <ng-container
                *ngTemplateOutlet="infoTemplate; context: { label: 'Sender', text: approvalRequest.senderName }">
            </ng-container>

            <div class="pair-info-container">
                <ng-container
                    *ngTemplateOutlet="infoTemplate; context: { label: 'Creation date', text: moment(approvalRequest.createdOn).parseZone().format('MM/DD/YYYY') }">
                </ng-container>

                <ng-container
                    *ngTemplateOutlet="infoTemplate; context: { label: 'No later than', text: job.noLaterThan ? moment(job.noLaterThan).parseZone().format('MM/DD/YYYY') : '---' }">
                </ng-container>
            </div>

            <ng-container
                *ngTemplateOutlet="infoTemplate; context: { label: 'Type / Category', text: approvalRequest.type }">
            </ng-container>

            <div class="pair-info-container">

                <ng-container *ngIf="approvalRequest.budget">
                    <ng-container
                        *ngTemplateOutlet="infoTemplate; context: { label: 'Budget', text: approvalRequest.budget | currency:'USD':'symbol-narrow':'.2-2' }">
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="approvalRequest.approvedBudget">
                    <ng-container
                        *ngTemplateOutlet="infoTemplate; context: { label: 'Approved Budget', text: approvalRequest.approvedBudget | currency:'USD':'symbol-narrow':'.2-2' }">
                    </ng-container>
                </ng-container>
            </div>

            <ng-container *ngIf="approvalRequest.comment">
                <ng-container
                    *ngTemplateOutlet="infoTemplate; context: { label: 'Comment', text: approvalRequest.comment }">
                </ng-container>
            </ng-container>

            <ng-container *ngTemplateOutlet="infoTemplate; context: { label: 'Documents', text: null }">
            </ng-container>

            <div class="documents-container">
                <div class="document" *ngFor="let document of approvalRequest.documents"
                    [class.approved]="document.isApproved && approvalRequest.proposalStatusId === ProposalStatus.Approved">
                    <div class="document-details" (click)="showDocument(document)">
                        <div class="document-meta-container">
                            <div class="document-meta">
                                <span class="document-status-label approved" *ngIf="document.isApproved">
                                    <mat-icon>task_alt</mat-icon>APPROVED
                                </span>

                                <span class="document-status-label negotiation" *ngIf="document.isNegotiationLocked">
                                    <mat-icon>replay</mat-icon>IN NEGOTIATION
                                </span>

                                <span class="document-name">{{ document.description?.trim() || document.getName()
                                    }}</span>
                                <span class="document-type">{{ document.type }}</span>
                            </div>

                            <div class="document-vote-status">
                                <mat-icon *ngIf="document.isVotedByCurrentUser"
                                    [style.padding-right]="!isDocumentMenuVisible ? '15px' : 0">thumb_up</mat-icon>
                                <button class="document-menu" *ngIf="isDocumentMenuVisible" mat-flat-button
                                    [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                            </div>

                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="toggleVote(document.proposalDocumentId)"
                                    *ngIf="!document.isVotedByCurrentUser">Vote Yes</button>
                                <button mat-menu-item (click)="toggleVote(document.proposalDocumentId)"
                                    *ngIf="document.isVotedByCurrentUser">Vote No</button>
                                <button mat-menu-item *ngIf="!document.isNegotiationLocked"
                                    (click)="setNegotiationModal(document); commentProposalModal.open()">Negotiate</button>
                                <button mat-menu-item
                                    (click)="budgetFormModel.get('proposalDocumentId').setValue(document.proposalDocumentId); budgetProposalModal.open()"
                                    *ngIf="approvalRequest.boardMemberType === BoardMemberRole.Approver">Approve</button>
                            </mat-menu>
                        </div>

                        <div class="document-meta-container">
                            <div>
                                <span>Cost:</span>
                                <span class="amount">{{ document.proposalAmount | currency: 'USD' }}</span>
                                <span class="recommended" *ngIf="document.isRecommended">(recommended)</span>
                            </div>
                            <div>
                                <span>
                                    <button mat-flat-button
                                        (click)="votersModal.open(document.voters); $event.stopPropagation()"
                                        [disabled]="!document?.voters?.length" class="show-voters">
                                        {{ document.voters?.length || 0 }}
                                        {{ (document.voters?.length || 0) === 1 ? 'vote' : 'votes' }}
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

        <div class="actions-container md-view">
            <ng-container *ngIf="approvalRequest && pageType === PageType.Customer">
                <ng-container
                    *ngIf="!customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
                    <action-button [clickAction]="navigateBack.bind(self)" [icon]="ButtonIcons.Exit" [name]="'Back'">
                    </action-button>

                    <action-button [subpage]="'thread'" [icon]="ButtonIcons.Comment" [name]="'Thread'"></action-button>

                    <action-button [clickAction]="commentProposalModal.open.bind(commentProposalModal)"
                        (click)="modalAction = 'void'; commentFormModel.reset();" [icon]="ButtonIcons.Cancel"
                        [name]="'Void\nRequest'" *ngIf="isActiveProposal">
                    </action-button>
                </ng-container>

                <div class="actions-placeholder-message" *ngIf="customerPreferences.preferences.isNotificationDisabled || customerPreferences.preferences.isJobAutoSkipped">
                    <span
                        *ngIf="customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
                        {{ ActionsPlaceholderSettings.NotificationDisabled }}</span>
                    <span
                        *ngIf="customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
                        {{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
                    <span
                        *ngIf="customerPreferences.preferences.isNotificationDisabled && customerPreferences.preferences.isJobAutoSkipped">
                        {{ ActionsPlaceholderSettings.BothDisabled }}</span>
                </div>

            </ng-container>

            <ng-container *ngIf="approvalRequest && pageType === PageType.BoardMember">
                <action-button [clickAction]="navigateBack.bind(self)" [icon]="ButtonIcons.Exit" [name]="'Back'">
                </action-button>

                <action-button [clickAction]="commentProposalModal.open.bind(commentProposalModal)"
                    (click)="modalAction = 'decline'; commentFormModel.reset();" [icon]="ButtonIcons.Cancel"
                    [name]="'Decline\nRequest'"
                    *ngIf="isActiveProposal && approvalRequest.boardMemberType === BoardMemberRole.Approver">
                </action-button>

                <action-button [subpage]="'thread'" [icon]="ButtonIcons.Comment" [name]="'Thread'"></action-button>
            </ng-container>
        </div>

        <ng-template #infoTemplate let-label="label" let-text="text">
            <div class="details">
                <div class="details-text">
                    <span class="label" *ngIf="label">{{ label }}</span>
                    <span *ngIf="text">{{ text }}</span>
                </div>
            </div>
        </ng-template>

    </mat-sidenav-content>
</mat-sidenav-container>

<generic-modal #votersModal>
    <ng-template #modalBody let-data="data">
        <contacts-list [contacts]="data" [pageTitle]="'Voted by'" [isInline]="true" class="inline-list"></contacts-list>
    </ng-template>
    <ng-template #modalActions>
        <button mat-flat-button (click)="votersModal.hide()">Ok</button>
    </ng-template>
</generic-modal>

<generic-modal #commentProposalModal>
    <ng-template #modalHeading>
        <span *ngIf="modalAction === 'decline'">Decline Proposal</span>
        <span *ngIf="modalAction === 'void'">Void Proposal</span>
        <span *ngIf="modalAction === 'negotiate'">Negotiate</span>
    </ng-template>

    <ng-template #modalBody>
        <div class="brief-form-container">
            <form [formGroup]="commentFormModel">
                <mat-form-field [floatLabel]="'always'">
                    <mat-label>Reason</mat-label>
                    <textarea matInput formControlName="comment" rows="4"></textarea>
                </mat-form-field>
            </form>
        </div>
    </ng-template>
    <ng-template #modalActions>
        <button mat-raised-button type="button" class="primary" (click)="declineProposal(); commentProposalModal.hide()"
            [disabled]="commentFormModel.invalid" *ngIf="modalAction === 'decline'">Decline</button>
        <button mat-raised-button type="button" class="primary" (click)="voidProposal(); commentProposalModal.hide()"
            [disabled]="commentFormModel.invalid" *ngIf="modalAction === 'void'">Void</button>
        <button mat-raised-button type="button" class="primary"
            (click)="negotiateDocument(selectedForNegotiation); commentProposalModal.hide()"
            *ngIf="modalAction === 'negotiate'">Negotiate</button>
        <button mat-raised-button class="secondary" type="button" (click)="commentProposalModal.hide()">Cancel</button>
    </ng-template>
</generic-modal>

<generic-modal #budgetProposalModal>
    <ng-template #modalHeading>Approve Proposal</ng-template>

    <ng-template #modalBody>
        <div class="brief-form-container">
            <form [formGroup]="budgetFormModel">
                <div class="line-info" *ngIf="approvalRequest.budget">
                    <span>Budget:</span>
                    <span>{{approvalRequest.budget | currency:'USD'}}</span>
                </div>

                <mat-form-field [floatLabel]="'always'">
                    <mat-label>Approved Price</mat-label>
                    <input matInput currencyMask
                        [options]="{ prefix: '', align: 'left', inputMode: 1, min: 0, max: 999999999 }"
                        formControlName="budget" (keypress)="validateNumberKey($event)" />
                </mat-form-field>
            </form>
        </div>
    </ng-template>

    <ng-template #modalActions>
        <button mat-raised-button type="button" class="primary" (click)="approveProposal(); budgetProposalModal.hide()"
            [disabled]="budgetFormModel.invalid">Approve</button>
        <button mat-raised-button class="secondary" type="button" (click)="budgetProposalModal.hide()">Cancel</button>
    </ng-template>
</generic-modal>